export const Brand = ({ large = false }) =>
  large ? (
    <div className="flex items-center gap-5" data-testid="brand">
      <img src="/img/logo.jpg" alt="Empreendi Bellas" className="h-28 w-28 shrink-0 rounded-xl object-cover shadow-[0_8px_30px_rgb(0,0,0,0.08)] sm:h-32 sm:w-32" data-testid="brand-logo" />
      <div className="leading-tight">
        <p className="font-display text-3xl font-semibold text-neutral-900">Bella Gestão</p>
        <p className="mt-1 text-[10px] font-semibold uppercase tracking-[0.3em] text-gold-dark">Empreendi Bellas</p>
      </div>
    </div>
  ) : (
    <div className="flex items-center gap-3" data-testid="brand">
      <img src="/img/logo-mark.jpg" alt="Empreendi Bellas" className="h-11 w-12 shrink-0 rounded-lg object-cover" data-testid="brand-logo" />
      <div className="leading-tight">
        <p className="font-display text-xl font-semibold text-neutral-900">Bella Gestão</p>
        <p className="whitespace-nowrap text-[9px] font-semibold uppercase tracking-[0.2em] text-gold-dark">Empreendi Bellas</p>
      </div>
    </div>
  );
